import React, { useState, useEffect, useRef } from 'react'
import {
  SMALL_DESKTOP,
  LARGE_DESKTOP,
  MEDIUM_DESKTOP,
  XLARGE_DESKTOP
} from '../constants'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import ListComponent from '../InteractionComponents/ListComponent'
import TextInputComponent from '../InteractionComponents/TextInputComponent'
import MultipleChoiceText from '../InteractionComponents/MultipleChoiceText'
import MultipleChoiceImage from '../InteractionComponents/MultipleChoiceImage'
import MultipleAnswerText from '../InteractionComponents/MultipleAnswerText'
import MultipleAnswerImage from '../InteractionComponents/MultipleAnswerImage'
import TrueFalseSingleComponent from '../InteractionComponents/TrueFalseSingleComponent'
import TrueFalseChoiceComponent from '../InteractionComponents/TrueFalseChoiceComponent'
import SliderStaticComponent from '../InteractionComponents/SliderStaticComponent'
import DragAndDropMCQ from '../InteractionComponents/DragAndDropMCQ'
import SliderDynamicComponent from '../InteractionComponents/SliderDynamicComponent'
import NumberPickerComponent from '../InteractionComponents/NumberPickerComponent'
import TypeAnswerComponent from '../InteractionComponents/TypeAnswerComponent'
import FillTheBlankText from '../InteractionComponents/FillTheBlankText'
import InlineChoiceText from '../InteractionComponents/InlineChoiceText'
import FillInHighlight from '../InteractionComponents/FillInHighlight'
import HotspotComponent from '../InteractionComponents/HotspotComponent'
import ImageCoreComponent from '../NonInteractionComponents/ImageCoreComponent'
import AudioComponent from '../NonInteractionComponents/AudioComponent'
import PDFCoreComponent from '../NonInteractionComponents/PDFCoreComponent'
import VideoCoreComponent from '../NonInteractionComponents/VideoCoreComponent'
import ThreeDModelComponent from '../NonInteractionComponents/ThreeDModelComponent'
import NormalVideoComponent from '../NonInteractionComponents/NormalVideoComponent'
import RichTextEditor from '../RichTextEditor/RichTextEditor'
import MatchTableComponent from '../InteractionComponents/MatchTableComponent'
import FractionComponent from '../InteractionComponents/FractionComponent'
import H5PComponent from '../h5pComponent/h5pComponent'
import IFrameComponent from '../NonInteractionComponents/iFrameComponent'
import MarkIcon from '@material-ui/icons/LocationOn'
import Lottie from 'react-lottie'
import orange_ripple from '../OrangeAnime/orange_ripple.json'
import { LocationFilled } from '@carbon/icons-react'
import { HintIcon } from '../UIUtilsFiles/HintIcon'

function SmartPaperBaseScreen(props) {
  //Values from client
  const {
    initial,
    smartPaperData,
    canvasDimension,
    currentMode,
    isVerifyMode,
    isPractice,
    Completed,
    explanationClick,
    isActive,
    IsReadonly,
    FollowTheFlow,
    priorityActive,
    outsideClick,
    controlsList,
    isVideoPlaying,
    screenMode,
    projectName,
    allMarkerStatus,
    audioStop,
    handleVideoClose,
    handleAudioClose,
    isSeqPlay,
    feedPlay,
    isRecording,
    isRecordPlaying,
    isReplayHappening,
    hintMessage,
    isPageRefresh,
    isCanvas,
    isAudioPlaying
  } = props

  //Values to client
  const {
    handleValueChange,
    handleValueChangeEmbeded,
    handleAttemptChange,
    setPriorityChange,
    setSequenceMessageChange,
    setOutsideClickChange,
    setExplanationText,
    setExplanationStatus,
    setExplanationVisible,
    handleSuccessModal,
    handleSucAndFailFeedback,
    handleAiFeedbackChange,
    onHintIconChange,
    onRecordAlert
  } = props

  //smart video props
  const {
    setIsVideoPlaying,
    setVideoResume,
    setAllMarkerStatus,
    setTextPopupVisible,
    setExternalPopupVisible,
    ContainedView,
    videoResume,
    currentVideoPlayer,
    smartVideoStatus,
    sendDataForApi,
    isContainedView,
    setSmartVideoStatus,
    isResetClick
  } = props

  //smart video useref
  const {
    setCurrentPopupValue,
    setCurrentVideoPlayer,
    setCurrentContainedID,
    setCurrentAudioPlayer,
    setCurrentAudioPlaying
  } = props

  //values for enhanced popup
  const { handleEnhancedClick } = props

  const [attempts, setAttempts] = useState(0)
  const [attemptsPractice, setAttemptsPractice] = useState(0)
  //Controls list contants
  // const [controlsList, setControlsList] = useState([])
  const [dropValue, setDropValue] = useState({})
  const [displayDone, setDisplayDone] = useState(false)

  //handle audioplaying
  const [audioComponentPlaying, setAudioComponentPlaying] = useState(-1)

  //selected drop down
  let currentSelectedDropdown = useRef()

  useEffect(() => {
    console.log('FollowTheFlow', FollowTheFlow)
    console.log('priorityActive', priorityActive)
  }, [FollowTheFlow, priorityActive])

  //Get answer explanation from component
  function handleExplanationChange(explanationStatus, explanationString) {
    if (explanationString && explanationString !== '') {
      setExplanationText(explanationString)
      setExplanationStatus(explanationStatus)
      setExplanationVisible(true)
    } else {
      setExplanationVisible(false)
    }
  }

  //Display right or wrong feedback
  function handleSuccessChange(successValue) {
    if (isPractice) {
      //handleSuccessModal(successValue)
    }
    currentSelectedDropdown.current = undefined
  }

  // function handleSucAndFailFeedback(feedback) {
  //   if (isPractice) {
  //     handleSucAndFailFeedbackChange(feedback)
  //   }
  // }

  function handleAiFeedback(feedback, feedbackStatus) {
    if (isPractice) {
      handleAiFeedbackChange(feedback, feedbackStatus)
    }
  }

  function onPriorityChange(componentPriority) {
    setPriorityChange(componentPriority)
  }

  function sequenceMessage(componentHintMessage) {
    // setSequenceMessageChange(componentHintMessage)
  }

  function onOutsideClickChange(clickOutside) {
    setOutsideClickChange(clickOutside)
  }

  function onSelectedItem(selectedItem) {
    currentSelectedDropdown.current = selectedItem
  }

  const defaultOptionsOrange = {
    loop: true,
    autoplay: true,
    animationData: orange_ripple,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <span style={{ pointerEvents: currentMode === 'LABEL' ? 'none' : 'auto' }}>
      {smartPaperData.InputRows &&
        smartPaperData.InputRows.length > 0 &&
        smartPaperData.InputRows.map((box, index) => {
          const { X, Y, Height, Width } = box
          const defltVal = controlsList.find((c) => c.CtlId === box.ControlID)
          const embedDefaultValue = defltVal
            ? {
                ...defltVal,
                CtlValue: defltVal.CtlValue.Answer
              }
            : undefined
          let controlDimension = {}
          let heightPx = 0
          let widthPx = 0
          if (canvasDimension && Height && Width) {
            heightPx =
              (canvasDimension.height * parseFloat(Height.split('%')[0])) / 100
            widthPx =
              (canvasDimension.width * parseFloat(Width.split('%')[0])) / 100
          }
          controlDimension = {
            heightPx: heightPx,
            widthPx: widthPx
          }

          if (box.PluginId === 'Label') {
            const { Value, FontSize, X, Y } = box
            return (
              <p
                key={index.toString()}
                style={{
                  fontSize: FontSize,
                  top: Y,
                  left: X,
                  position: 'absolute'
                }}
              >
                {Value}
              </p>
            )
          } else if (
            box.PluginId === 'TextArea' ||
            box.PluginId === 'SCTextArea'
          ) {
            const {
              Value,
              ControlID,
              FontSize,
              X,
              Y,
              Width,
              FontColor,
              TextAlign
            } = box
            return (
              <span
                key={index.toString()}
                id={ControlID}
                style={{
                  width: Width + '%',
                  height: Height + '%',
                  fontSize:
                    FontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : FontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : FontSize === 'XLARGE'
                      ? XLARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  top: Y,
                  left: X,
                  position: 'absolute',
                  color:
                    priorityActive === box.Priority ? '#000000' : FontColor,
                  margin: 0,
                  backgroundColor:
                    priorityActive === box.Priority ? '#ffffff' : box.FillColor,
                  borderColor: FontColor,
                  borderWidth: '1px',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontFamily,
                  fontStyle: box.Italic ? 'italic' : 'normal',
                  fontWeight: box.Bold ? 'bold' : 'normal',
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto',
                  overflowX: 'hidden',
                  borderRadius: '10px',
                  display: 'flex',
                  //  alignItems: 'center',
                  textAlign: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'left',
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'left',
                  paddingLeft: '5px',
                  paddingRight: '5px'
                }}
              >
                {Value}
              </span>
            )
          } else if (box.PluginId === 'AGInput') {
            return (
              <TextInputComponent
                key={index.toString()}
                textInputData={box}
                x={X}
                y={Y}
                onValueChange={handleValueChange}
                defaultValue={defltVal ? defltVal.CtlValue.Answer : ''}
                isPractice={isPractice}
                completed={Completed}
                isActive={isActive}
                isReadonly={IsReadonly}
                followTheFlow={FollowTheFlow}
                currentPriority={priorityActive}
                onPriorityChange={onPriorityChange}
                explanationClick={explanationClick && explanationClick}
                onExplanationVisible={handleExplanationChange}
                isVerifyMode={isVerifyMode}
                handleSuccessChange={handleSuccessChange}
                handleSucAndFailFeedback={handleSucAndFailFeedback}
                isSeqPlay={isSeqPlay}
                feedPlay={feedPlay}
                isAudioPlaying={isAudioPlaying}
              />
              // {/* {isPractice &&
              //   !isReplayHappening &&
              //   !isSeqPlay &&
              //   !feedPlay &&
              //   !isRecording &&
              //   !isRecordPlaying &&
              //   priorityActive === box.Priority &&
              //   hintMessage !== '' && (
              //     <div
              //       style={{
              //         width: box.Width + '%',
              //         height: box.Height + '%',
              //         left: X,
              //         top: Y,
              //         position: 'absolute'
              //       }}
              //     >
              //       <HintIcon onHintIconClicked={onHintIconChange} />
              //     </div>
              //   )} */}
            )
          } else if (
            box.PluginId === 'AGTextList' ||
            box.PluginId === 'AGInkList'
          ) {
            return (
              <ListComponent
                key={index.toString()}
                listData={box}
                x={X}
                y={Y}
                width={Width}
                height={Height}
                onValueChange={handleValueChange}
                defaultValue={defltVal ? defltVal.CtlValue : ''}
                isPractice={isPractice}
                completed={Completed}
                isActive={isActive}
                isReadonly={
                  isSeqPlay ||
                  feedPlay ||
                  isRecordPlaying ||
                  isRecording ||
                  isReplayHappening ||
                  currentMode === 'LABEL'
                    ? true
                    : false
                }
                followTheFlow={FollowTheFlow}
                currentPriority={priorityActive}
                onPriorityChange={onPriorityChange}
                explanationClick={explanationClick && explanationClick}
                onExplanationVisible={handleExplanationChange}
                isVerifyMode={isVerifyMode}
                outsideClick={outsideClick}
                handleOutSideClick={onOutsideClickChange}
                handleSelectedItem={onSelectedItem}
                currentSelectedItem={currentSelectedDropdown}
                handleSuccessChange={handleSuccessChange}
                handleSucAndFailFeedback={handleSucAndFailFeedback}
                isAudioPlaying={isAudioPlaying}
              />
            )
          } else if (
            box.PluginName === 'SSMultipleChoice' &&
            ((box.DisplayType === 'radioButton' &&
              (box.AnswerType === 'text' || box.AnswerType === 'inktotext')) ||
              box.DisplayType === 'chatBubbles')
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <MultipleChoiceText
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  handleAiFeedback={handleAiFeedback}
                  controlDimension={controlDimension}
                  isCanvas={isCanvas}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            box.PluginName === 'SSMultipleChoice' &&
            box.DisplayType === 'radioButton' &&
            (box.AnswerType === 'image' || box.AnswerType === 'ink')
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <MultipleChoiceImage
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSMultipleChoice' &&
                box.DisplayType === 'rangeSlideStatic' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSMultipleChoice' &&
                box.DisplayType === 'rangeSlideStatic'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <SliderStaticComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSMultipleChoice' &&
                box.DisplayType === 'Drag and Drop' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSMultipleChoice' &&
                box.DisplayType === 'Drag and Drop'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <DragAndDropMCQ
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  screenMode={screenMode}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (
            box.PluginName === 'SSMultipleAnswer' &&
            ((box.DisplayType === 'checkbox' &&
              (box.AnswerType === 'text' || box.AnswerType === 'inktotext')) ||
              box.DisplayType === 'chatBubbles')
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  borderRadius: '8px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <MultipleAnswerText
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  controlDimension={controlDimension}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            box.PluginName === 'SSMultipleAnswer' &&
            box.DisplayType === 'checkbox' &&
            (box.AnswerType === 'image' || box.AnswerType === 'ink')
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  borderRadius: '8px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <MultipleAnswerImage
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          }
          // else if (
          //   box.PluginName === 'SSTrueFalse' &&
          //   box.DisplayType === 'single'
          // ) {
          //   return (
          //     <div
          //       key={index.toString()}
          //       style={{
          //         top: Y,
          //         left: X,
          //         height: Height + '%',
          //         width: Width + '%',
          //         position: 'absolute',
          //         zIndex: currentMode === 'LABEL' ? 3 : 5,
          //         fontFamily: box.FontStyle,
          //         fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
          //         fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
          //         pointerEvents:
          //           isReplayHappening ||
          //           isSeqPlay ||
          //           feedPlay ||
          //           isRecording ||
          //           isRecordPlaying
          //             ? 'none'
          //             : 'auto',
          //         backgroundColor:
          //           FollowTheFlow && priorityActive === box.Priority
          //             ? '#ffffff'
          //             : undefined,
          //         borderRadius: '10px'
          //       }}
          //     >
          //       <TrueFalseSingleComponent
          //         mcData={box}
          //         key={box.ControlID}
          //         isPractice={isPractice}
          //         completed={Completed}
          //         isActive={isActive}
          //         onAttemptChange={handleAttemptChange}
          //         onValueChange={handleValueChangeEmbeded}
          //         defaultValue={embedDefaultValue}
          //         isVerifyMode={isVerifyMode}
          //         explanationClick={explanationClick && explanationClick}
          //         onExplanationVisible={handleExplanationChange}
          //         handleSuccessChange={handleSuccessChange}
          //         isEmbeded={true}
          //         followTheFlow={FollowTheFlow}
          //         currentPriority={priorityActive}
          //         onPriorityChange={onPriorityChange}
          //         sequenceMessage={sequenceMessage}
          //         handleSucAndFailFeedback={handleSucAndFailFeedback}
          //         isResetClick={isResetClick}
          //       />
          //       {/* {isPractice &&
          //         !isReplayHappening &&
          //         !isSeqPlay &&
          //         !feedPlay &&
          //         !isRecording &&
          //         !isRecordPlaying &&
          //         priorityActive === box.Priority &&
          //         hintMessage !== '' && (
          //           <HintIcon onHintIconClicked={onHintIconChange} />
          //         )} */}
          //     </div>
          //   )
          // }
          else if (box.PluginName === 'SSTrueFalse') {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  borderWidth: '1px',
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  borderRadius: '8px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <TrueFalseChoiceComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'slider' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'slider'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <SliderDynamicComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  initial={initial}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'numberPicker' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'numberPicker'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  borderRadius: '8px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <NumberPickerComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'TypeAnswer' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginName === 'SSRotatingDial' &&
                box.DisplayType === 'TypeAnswer'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  borderWidth: '1px',
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  borderColor: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'orange'
                      : 'black'
                    : box.SelectionColor,
                  borderStyle: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'solid'
                      : 'dashed'
                    : 'solid',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <TypeAnswerComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  initial={initial}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                />
              </div>
            )
          } else if (
            box.PluginName === 'SSFillinTheBlanks' &&
            box.DisplayType === 'type'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '8px',
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <FillTheBlankText
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  initial={initial}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            box.PluginName === 'SSFillinTheBlanks' &&
            box.DisplayType === 'inlineChoice'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : dropValue.id === box.ControlID
                      ? dropValue.dropValue
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '8px',
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <InlineChoiceText
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  initial={initial}
                  onDropDownlick={(dropValue) => {
                    setDropValue(dropValue)
                  }}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            box.PluginName === 'SSFillinTheBlanks' &&
            box.DisplayType === 'highlight'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex:
                    currentMode === 'LABEL'
                      ? 3
                      : displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? 10
                        : 5
                      : 5,
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '8px',
                  border:
                    displayDone.id === box.ControlID
                      ? displayDone.displayDone
                        ? '2px solid #ffc42d'
                        : ''
                      : '',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <FillInHighlight
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                />
                {/* {isPractice &&
                  !isReplayHappening &&
                  !isSeqPlay &&
                  !feedPlay &&
                  !isRecording &&
                  !isRecordPlaying &&
                  priorityActive === box.Priority &&
                  hintMessage !== '' && (
                    <HintIcon onHintIconClicked={onHintIconChange} />
                  )} */}
              </div>
            )
          } else if (
            FollowTheFlow
              ? projectName === 'SmartCanvasLP' &&
                screenMode !== 'desktop' &&
                (box.PluginName === 'SSMultipleChoice' ||
                  box.PluginName === 'SSMultipleAnswer' ||
                  box.PluginName === 'SSTrueFalse' ||
                  box.PluginName === 'SSRotatingDial' ||
                  box.PluginName === 'SSFillinTheBlanks') &&
                box.Priority <= priorityActive
              : projectName === 'SmartCanvasLP' &&
                screenMode !== 'desktop' &&
                (box.PluginName === 'SSMultipleChoice' ||
                  box.PluginName === 'SSMultipleAnswer' ||
                  box.PluginName === 'SSTrueFalse' ||
                  box.PluginName === 'SSRotatingDial' ||
                  box.PluginName === 'SSFillinTheBlanks')
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: '5%',
                  width: '5%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5
                }}
                onClick={() => {
                  handleEnhancedClick(box, true)
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Lottie
                    options={defaultOptionsOrange}
                    width={50}
                    height={50}
                  />
                  <MarkIcon
                    key={index.toString()}
                    style={{
                      width: '25px',
                      height: '25px',
                      position: 'absolute',
                      zIndex: 1,
                      cursor: 'pointer',
                      color: Completed === 0 ? 'red' : '#0bff31',
                      top: 0
                    }}
                  />
                </div>
              </div>
            )
          } else if (box.PluginName === 'SPHotspot') {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : undefined,
                  borderRadius: '10px',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <HotspotComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? box.PluginId === 'EnrichedPDF' && box.Priority <= priorityActive
              : box.PluginId === 'EnrichedPDF'
          ) {
            return <PDFCoreComponent pdfData={box} key={index} />
          } else if (
            FollowTheFlow
              ? box.PluginId === 'EnrichedAudio' &&
                box.Priority <= priorityActive
              : box.PluginId === 'EnrichedAudio'
          ) {
            return (
              <span
                style={{
                  pointerEvents:
                    isReplayHappening ||
                    isAudioPlaying ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : audioComponentPlaying >= 0
                      ? audioComponentPlaying === box.ControlID
                        ? 'auto'
                        : 'none'
                      : 'auto'
                }}
              >
                <AudioComponent
                  audioData={box}
                  key={index}
                  onAudioControlChange={(status, controlId) => {
                    if (status) {
                      setCurrentAudioPlayer(controlId)
                      setCurrentAudioPlaying(true)
                      setAudioComponentPlaying(controlId)
                    } else {
                      setCurrentAudioPlayer(undefined)
                      setCurrentAudioPlaying(undefined)
                      setAudioComponentPlaying(-1)
                    }
                  }}
                  isVideoPlaying={isVideoPlaying}
                  audioStop={audioStop}
                  handleAudioClose={(audioCloseStatus) => {
                    handleAudioClose(audioCloseStatus)
                  }}
                  isRecording={isRecording}
                  isRecordPlaying={isRecordPlaying}
                  isSeqPlay={isSeqPlay}
                  feedPlay={feedPlay}
                />
              </span>
            )
          } else if (
            box.PluginId === 'HotspotImages' ||
            (box.PluginId === 'TextInk' && box.DisplayType === 'ink')
          ) {
            return (
              <ImageCoreComponent
                imageData={box}
                key={index}
                priorityActive={priorityActive}
              />
            )
          } else if (
            FollowTheFlow
              ? box.PluginId === 'TextInk' &&
                box.DisplayType === 'inktotext' &&
                box.Priority <= priorityActive
              : box.PluginId === 'TextInk' && box.DisplayType === 'inktotext'
          ) {
            const { Url, ControlID, FontSize, X, Y, Width, Color, TextAlign } =
              box
            return (
              <div
                key={index.toString()}
                id={ControlID}
                style={{
                  width: Width + '%',
                  height: Height + '%',
                  fontSize:
                    FontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : FontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  top: Y,
                  left: X,
                  position: 'absolute',
                  color: Color,
                  margin: 0,
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : box.FillColor,
                  borderColor: Color,
                  borderWidth: '1px',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  fontFamily: box.FontFamily,
                  fontStyle: box.Italic ? 'italic' : 'normal',
                  fontWeight: box.Bold ? 'bold' : 'normal',
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto',
                  overflowX: 'hidden',
                  paddingLeft: '1%',
                  paddingRight: '1%',
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'center'
                }}
              >
                <InlineMath>{Url}</InlineMath>
              </div>
            )
          } else if (
            FollowTheFlow
              ? box.PluginId === 'EnrichedPlayer' &&
                box.Priority <= priorityActive
              : box.PluginId === 'EnrichedPlayer'
          ) {
            return (
              <VideoCoreComponent
                videoData={box}
                key={index}
                onVideoControlChange={(status, currentVideoID) => {
                  setCurrentVideoPlayer(currentVideoID)
                  setIsVideoPlaying(status)
                  setVideoResume(false)
                }}
                videoResume={
                  videoResume && currentVideoPlayer.current === box.ControlID
                    ? true
                    : false
                }
                markerStatusList={
                  smartVideoStatus[box.ControlID] &&
                  smartVideoStatus[box.ControlID]
                }
                handleMarkStatus={(markerStatus) => {
                  setAllMarkerStatus(markerStatus)
                }}
                onPopupValueChange={(popupMarker, controlId) => {
                  setVideoResume(false)
                  popupMarker.map((markData) => {
                    if (
                      projectName === 'SmartCanvas' ||
                      projectName === 'SmartCanvasLP'
                    ) {
                      setCurrentVideoPlayer(controlId)
                      setCurrentContainedID(markData)
                      sendDataForApi(markData)
                    } else {
                      if (ContainedView && ContainedView !== null) {
                        ContainedView.map((containedData, index) => {
                          if (containedData.SlideID === markData) {
                            setCurrentVideoPlayer(controlId)
                            setCurrentContainedID(markData)
                            sendDataForApi(containedData.ContentID)
                          }
                        })
                      }
                    }
                  })
                }}
                completed={Completed}
                onNormalPopupClick={(markValue, controlId) => {
                  let allMarkerStatusCopy = {
                    ...allMarkerStatus
                  }
                  allMarkerStatusCopy[markValue] = 'working'
                  setAllMarkerStatus(allMarkerStatusCopy)
                  const smartVideoStatusCopy = { ...smartVideoStatus }
                  smartVideoStatusCopy[controlId] = allMarkerStatusCopy
                  setSmartVideoStatus(smartVideoStatusCopy)
                }}
                handleVideoClose={(videoCloseStatus) => {
                  handleVideoClose(videoCloseStatus)
                }}
                isRecording={isRecording}
                isRecordPlaying={isRecordPlaying}
                isSeqPlay={isSeqPlay}
                feedPlay={feedPlay}
                isReplayHappening={isReplayHappening}
                onRecordAlert={(status) => onRecordAlert(status)}
                priorityActive={priorityActive}
                isContainedView={isContainedView}
                followTheFlow={FollowTheFlow}
                isActive={isActive}
              />
            )
          } else if (
            FollowTheFlow
              ? box.PluginId == 'PopupSlide' && box.Priority <= priorityActive
              : box.PluginId == 'PopupSlide'
          ) {
            if (box.MarkData.MarkerType !== 'guidedActivity') {
              let markerStatusList = smartVideoStatus[box.ControlID]
              let checkMarkPresent =
                markerStatusList &&
                markerStatusList.hasOwnProperty(box.MarkData.MarkerValue)
              return (
                <div
                  key={index.toString()}
                  className={
                    Completed === 0 && isActive
                      ? checkMarkPresent
                        ? 'marker-cont bg-yellow '
                        : 'marker-cont bg-blue'
                      : 'marker-cont bg-green'
                  }
                  style={{
                    top: Y,
                    left: X,
                    pointerEvents:
                      isReplayHappening ||
                      isSeqPlay ||
                      feedPlay ||
                      isRecording ||
                      isRecordPlaying ||
                      currentMode === 'LABEL'
                        ? 'none'
                        : 'auto'
                  }}
                  onClick={() => {
                    if (box.MarkData && box.MarkData.MarkerType === 'popup') {
                      setExternalPopupVisible(false)
                      setCurrentPopupValue(box.MarkData)
                      setCurrentVideoPlayer(box.ControlID)
                      setCurrentContainedID(box.MarkData.MarkerValue)
                      setTextPopupVisible(true)
                    } else if (
                      box.MarkData &&
                      box.MarkData.MarkerType === 'external'
                    ) {
                      setCurrentPopupValue(box.MarkData)
                      setCurrentVideoPlayer(box.ControlID)
                      setCurrentContainedID(box.MarkData.MarkerValue)
                      setTextPopupVisible(false)
                      setExternalPopupVisible(true)
                    } else {
                      if (
                        projectName === 'SmartCanvas' ||
                        projectName === 'SmartCanvasLP'
                      ) {
                        setCurrentPopupValue('popupSlide')
                        setCurrentVideoPlayer(box.ControlID)
                        setCurrentContainedID(box.MarkData.MarkerValue)
                        sendDataForApi(box.MarkData.MarkerValue)
                      } else {
                        if (ContainedView && ContainedView !== null) {
                          ContainedView.map((containedData, index) => {
                            if (
                              containedData.SlideID === box.MarkData.MarkerValue
                            ) {
                              setCurrentPopupValue('popupSlide')
                              setCurrentVideoPlayer(box.ControlID)
                              setCurrentContainedID(box.MarkData.MarkerValue)
                              sendDataForApi(containedData.ContentID)
                            }
                          })
                        }
                      }
                    }
                  }}
                >
                  <LocationFilled className='mark-icon-style' />
                </div>
              )
            } else {
              return
              // return (
              //   <div
              //     className='pop-up-guided-cont'
              //     onClick={() => {
              //       ContainedView.map((containedData, index) => {
              //         if (containedData.SlideID === box.MarkData.MarkerValue) {
              //           setCurrentPopupValue('popupSlide')
              //           setCurrentVideoPlayer(box.ControlID)
              //           setCurrentContainedID(box.MarkData.MarkerValue)
              //           sendDataForApi(containedData.ContentID)
              //         }
              //       })
              //     }}
              //   >
              //     <p className='pop-up-guided-label'>Additional help</p>
              //   </div>
              // )
            }
          } else if (
            FollowTheFlow
              ? box.PluginId === 'Visor3D' && box.Priority <= priorityActive
              : box.PluginId === 'Visor3D'
          ) {
            return (
              <ThreeDModelComponent
                ThreeDModelData={box}
                key={index}
                screenMode={screenMode}
                isVideoPlaying={isVideoPlaying}
              />
            )
          } else if (
            FollowTheFlow
              ? box.PluginId === 'RichText' && box.Priority <= priorityActive
              : box.PluginId === 'RichText'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 6,
                  borderWidth: '1px',
                  borderColor: 'black',
                  borderStyle: 'solid',
                  backgroundColor:
                    FollowTheFlow && priorityActive === box.Priority
                      ? '#ffffff'
                      : '',
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset'
                  // pointerEvents: box.Editable ? "auto" : "none",
                }}
              >
                <RichTextEditor
                  key={index}
                  initial={initial}
                  listData={box}
                  defaultValue={defltVal ? defltVal.CtlValue.Answer : ''}
                  onValueChange={handleValueChange}
                  completed={Completed}
                  isActive={isActive}
                  isEmbeded={true}
                  onDisplayDoneClick={(displayDone) => {
                    setDisplayDone(displayDone)
                  }}
                  onPriorityChange={onPriorityChange}
                  currentPriority={priorityActive}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginId === 'MatchTable' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginId === 'MatchTable'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  borderWidth: '1px',
                  fontFamily: box.FontFamily,
                  fontStyle: box.Italic === true ? 'italic' : 'normal',
                  fontWeight: box.Bold === true ? 'bold' : 'normal',
                  borderColor: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'orange'
                      : 'black'
                    : box.SelectionColor,
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <MatchTableComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (box.PluginId === 'Fraction') {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  borderWidth: '1px',
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  borderColor: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'orange'
                      : 'black'
                    : box.SelectionColor,
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <FractionComponent
                  fractionData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  defaultValue={embedDefaultValue}
                  isVerifyMode={isVerifyMode}
                  explanationClick={explanationClick && explanationClick}
                  onExplanationVisible={handleExplanationChange}
                  handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  followTheFlow={FollowTheFlow}
                  currentPriority={priorityActive}
                  onPriorityChange={onPriorityChange}
                  sequenceMessage={sequenceMessage}
                  handleSucAndFailFeedback={handleSucAndFailFeedback}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginId === 'H5pppp' &&
                box.Priority <= priorityActive
              : (projectName !== 'SmartCanvasLP' ||
                  (projectName === 'SmartCanvasLP' &&
                    screenMode === 'desktop')) &&
                box.PluginId === 'H5Ppppp'
          ) {
            return (
              <div
                key={index.toString()}
                style={{
                  top: Y,
                  left: X,
                  height: Height + '%',
                  width: Width + '%',
                  position: 'absolute',
                  zIndex: currentMode === 'LABEL' ? 3 : 5,
                  borderWidth: '1px',
                  fontFamily: box.FontStyle,
                  fontStyle: box.Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: box.Bold === 'True' ? 'bold' : 'normal',
                  borderColor: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'orange'
                      : 'black'
                    : box.SelectionColor,
                  filter: FollowTheFlow
                    ? box.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset',
                  pointerEvents:
                    Completed === 1 ||
                    !isActive ||
                    isAudioPlaying ||
                    isReplayHappening ||
                    isRecording ||
                    isRecordPlaying
                      ? 'none'
                      : FollowTheFlow
                      ? isPractice
                        ? box.Priority === priorityActive
                          ? 'auto'
                          : 'none'
                        : box.Priority > priorityActive
                        ? 'none'
                        : 'auto'
                      : 'auto'
                }}
              >
                <H5PComponent
                  mcData={box}
                  key={box.ControlID}
                  isPractice={isPractice}
                  completed={Completed}
                  isActive={isActive}
                  onAttemptChange={handleAttemptChange}
                  onValueChange={handleValueChangeEmbeded}
                  // defaultValue={embedDefaultValue}
                  // isVerifyMode={isVerifyMode}
                  // explanationClick={explanationClick && explanationClick}
                  // onExplanationVisible={handleExplanationChange}
                  // handleSuccessChange={handleSuccessChange}
                  isEmbeded={true}
                  // followTheFlow={FollowTheFlow}
                  // currentPriority={priorityActive}
                  // onPriorityChange={onPriorityChange}
                  // sequenceMessage={sequenceMessage}
                  // handleSucAndFailFeedback={handleSucAndFailFeedback}
                  isResetClick={isResetClick}
                  isPageRefresh={isPageRefresh}
                />
              </div>
            )
          } else if (
            FollowTheFlow
              ? box.PluginId === 'Webpage' && box.Priority <= priorityActive
              : box.PluginId === 'Webpage'
          ) {
            return (
              <span>
                <IFrameComponent
                  iFrameData={box}
                  key={index}
                  isEmbeded={true}
                />
              </span>
            )
          }
        })}
    </span>
  )
}
export { SmartPaperBaseScreen }
